export default __webpack_public_path__ + "static/media/talto_magazine.4b718b94.jpg";